module.exports = __webpack_public_path__ + "static/media/virtual_e_training_gray@2x.dce8b1fe.png";